import {z} from 'zod';

import {LeasingTargetGroupSchema} from './LeasingTargetGroupSchema';

export const FinancialProductSelectionSchema = z.object({
  termMonths: z.number(),
  downPaymentPercentage: z.number().nullable(),
  balloonPaymentPercentage: z.number().nullable(),
  leasingTargetGroup: LeasingTargetGroupSchema.nullable(),
  annualMileage: z.number().nullable(),
});
export type FinancialProductSelection = z.infer<typeof FinancialProductSelectionSchema>;
